const MANUFACTURERS_ABBOTT = "Abbott";
const MANUFACTURERS_BIOTRONIK = "Biotronik";
const MANUFACTURERS_MEDTRONIC = "Medtronic";
const MANUFACTURERS_BOSTON_SCIENTIFIC = "Boston Scientific";
export const MANUFACTURERS_SORIN_GROUP = "Sorin Group";

export const manufacturers = [
  MANUFACTURERS_ABBOTT,
  MANUFACTURERS_BIOTRONIK,
  MANUFACTURERS_MEDTRONIC,
  MANUFACTURERS_BOSTON_SCIENTIFIC,
  MANUFACTURERS_SORIN_GROUP,
];

export const EVOKE_BP_CUFF = "Evoke BP Cuff";
export const EVOKE_SCALE = "Evoke Scale";
export const EVOKE_HOLTER_MONITOR = "Evoke Holter Monitor";

export const evokeManufacturers = [
  EVOKE_BP_CUFF,
  EVOKE_HOLTER_MONITOR,
  EVOKE_SCALE,
];

export const MANUFACTURERS_WEARLINQ = "Wearlinq";

/* Ambulatory ECG patch vendors, kept as their own group and out of the list SaaS
 * account users see. */
export const patchManufacturers = [MANUFACTURERS_WEARLINQ];

export const allManufacturers = [
  ...manufacturers,
  ...evokeManufacturers,
  ...patchManufacturers,
];

export const BIOTRONIK = "Biotronik";

export const DISCONNECTED_MONITOR_DISALLOWED_MANUFACTURERS = [
  MANUFACTURERS_SORIN_GROUP,
];
